
'use client';

import React from 'react';
import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useTheme } from '@/context/theme-context';
import { cn } from '@/lib/utils';

export default function AppContent({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme();
  const pathname = usePathname() || '';
  const isLandingPageContext = ['/', '/signin', '/signup', '/privacy-policy'].includes(pathname);

  // Apply theme class to html element
  React.useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('theme-desert-oasis', 'theme-midnight-mosque', 'theme-rose-gold');
    if (theme && theme !== 'default') {
      root.classList.add(`theme-${theme}`);
    }
  }, [theme]);
  
  // Apply landing page specific body class
  React.useEffect(() => {
      if (isLandingPageContext) {
          document.body.classList.add('landing-page-body');
      } else {
          document.body.classList.remove('landing-page-body');
      }
  }, [isLandingPageContext]);

  return (
    <>
      {isLandingPageContext && <link rel="stylesheet" href="/landing-page.css" />}
      {/* Google tag (gtag.js) */}
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=G-R01LHPLC1M"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-R01LHPLC1M');
        `}
      </Script>
      {children}
    </>
  );
}
